import { DestroyRef, Directive, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatSelect } from "@angular/material/select";

/**
 * Ao abrir vazio, o mat-select marca a primeira opção como ativa (navegação por teclado) com fundo mais forte
 * que o zebrado, e ela parece já selecionada. Sem item ativo, as setas começam pela primeira opção.
 */
@Directive({
    selector: "mat-select[uiSemItemAtivo]",
    standalone: true,
})
export class SemItemAtivoDirective {
    constructor() {
        const select = inject(MatSelect);
        select.openedChange
            .pipe(takeUntilDestroyed(inject(DestroyRef)))
            .subscribe(aberto => {
                if (aberto && select.empty) select._keyManager?.setActiveItem(-1);
            });
    }
}
